import { APPROVE_OR_DECLINE_TRANSLATE_IMPROVEMENT_MUTATION } from './useApproveOrDeclineTranslateImprovement.graphql';
import {
  IApproveOrDeclineTranslateImprovementMutationGraphQLResponse,
  IApproveOrDeclineTranslateImprovementMutationVariables,
  IHandleApproveOrDeclineTranslateImprovementParams,
  IUseApproveOrDeclineTranslateImprovement,
  IUseApproveOrDeclineTranslateImprovementOptions,
} from './useApproveOrDeclineTranslateImprovement.interfaces';

import { useKanziMutation } from '../../apollo';

const useApproveOrDeclineTranslateImprovement = (
  options?: IUseApproveOrDeclineTranslateImprovementOptions,
): IUseApproveOrDeclineTranslateImprovement => {
  const { mutation, onCompleted, onError, token } = options ?? ({} as IUseApproveOrDeclineTranslateImprovementOptions);

  const [executeApproveOrDeclineTranslateImprovement, { loading: isLoading }] = useKanziMutation<
    IApproveOrDeclineTranslateImprovementMutationGraphQLResponse,
    IApproveOrDeclineTranslateImprovementMutationVariables
  >({
    mutation: mutation ?? APPROVE_OR_DECLINE_TRANSLATE_IMPROVEMENT_MUTATION,
    options: {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          translateImprovement: { approveOrDeclineTranslateImprovement: isCompleted },
        } = data;

        onCompleted({
          isCompleted,
        });
      },
      onError,
    },
    token,
  });

  const handleApproveOrDeclineTranslateImprovement = async ({
    id,
    isApproved,
  }: IHandleApproveOrDeclineTranslateImprovementParams): Promise<boolean> => {
    const { data } = await executeApproveOrDeclineTranslateImprovement({
      variables: {
        id,
        isApproved,
      },
    });

    return Boolean(data?.translateImprovement.approveOrDeclineTranslateImprovement);
  };

  return {
    handleApproveOrDeclineTranslateImprovement,
    isLoading,
  };
};

export { useApproveOrDeclineTranslateImprovement };
